import { render } from "./EmailOnboardingMode.vue?vue&type=template&id=7072e38c&scoped=true"
import script from "./EmailOnboardingMode.vue?vue&type=script&lang=js"
export * from "./EmailOnboardingMode.vue?vue&type=script&lang=js"

import "./EmailOnboardingMode.vue?vue&type=style&index=0&id=7072e38c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7072e38c"]])

export default __exports__